<template>
<div class="main-wrapper">
    <h1>Visão Geral</h1>

    <div class="flex">
      <section class="box">
        <div class="panel-header">
            <div class="title pull-left">Bem vindo revendedor!</div>
        </div>
        <div class="content-body">
          <p>Qualquer dúvida entre em contato com o organizador do evento.</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DealerOverview',
  data () {
    return {
    }
  }
}
</script>
